import { TranslateService } from '@ngx-translate/core';
import { computed, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Notification } from './models/notification.interface';
import { timer } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NotificationTypes } from './models/notification-types';

const ERRORS_REMOVE_TIMEOUT = 5000;
@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  public visibleNotifications: Signal<Notification[]> =
    computed(() => this.notifications().filter(n => !n.hidden));

  protected notifications: WritableSignal<Notification[]> = signal([]);
  constructor(private _translate: TranslateService) {}

  handleSuccessNotification(translateKey: string) {
    return this.addNotification({
      type: NotificationTypes.success,
      title: this._translate.instant(`${translateKey}.title`),
      message: this._translate.instant(`${translateKey}.message`),
      createdAt: new Date(),
      liveTime: environment.notificationsLiveTime,
    });
  }

  addNotification(notification: Notification): void {
    const updatedNotifications = [...this.notifications(), notification];

    const timeout = notification.liveTime ??
      (notification.type !== NotificationTypes.danger ? ERRORS_REMOVE_TIMEOUT : null);

    if (timeout) {
      timer(timeout)
        .pipe(tap(() => this.removeNotificationByErrorObject(notification.errorObject)))
        .subscribe();
    }

    this.notifications.set(updatedNotifications);
  }

  removeNotification(createdAt: number) {
    const updatedNotifications = this.notifications().filter(
      (n) => n.createdAt.getTime() !== createdAt,
    );

    this.notifications.set(updatedNotifications);
  }

  removeAllNotifications() {
    this.notifications.set([]);
  }

  protected removeNotificationByErrorObject(errorObject: any) {
    const updatedNotifications = this.notifications().filter(
      (n) => n.errorObject !== errorObject,
    );

    this.notifications.set(updatedNotifications);
  }

  protected hideNotification(createdAt: number) {
    const updatedNotifications = this.notifications().map((n) =>
      n.createdAt.getTime() === createdAt ? { ...n, hidden: true } : n,
    );

    this.notifications.set(updatedNotifications);
  }

  protected toggleExpanded(id: number) {
    const updatedNotifications = this.notifications().map((n, index) =>
      index === id ? { ...n, expanded: !n.expanded } : n,
    );

    this.notifications.set(updatedNotifications);
  }
}
